import { z } from 'zod'
import { Identity } from '~library/enums'
import { enumWithEmpty } from '~library/models'

/** 使用者資訊 Schema */
export const userProfileSchema = z.object({
  /** 會員卡號 */
  memberCardNumber: z.string(),
  /** 身份 */
  identity: enumWithEmpty(Identity),
  /** 會員姓名 */
  name: z.string(),
  /** 會員英文姓名 */
  englishName: z.string(),
  /** 企業代碼 */
  bizId: z.string(),
  /** 客戶名稱 */
  corporateLocalName: z.string(),
  /** 客戶英文名稱 */
  corporateEnglishName: z.string(),
  /** 是否已綁定企業會員 */
  binding: z.boolean(),
  /** JWT token */
  token: z.string().optional(),
  /** refresh token */
  refreshToken: z.string().optional(),
  /** 是否已同意條款 */
  agreeTerms: z.boolean(),
  /** 錯誤次數 */
  errorCount: z.number(),
  /** 場站 */
  station: z.string(),
  /** OTP剩餘時間 */
  otpRemainingTime: z.number(),
  /** email */
  email: z.string(),
  /** sseCode */
  sseCode: z.string(),
  /** 裝置Token	 */
  deviceToken: z.string().optional()
})

/** 使用者資訊 */
export interface UserProfile extends z.infer<typeof userProfileSchema> {}
